import React, { useMemo } from "react";
import {
  type Icon,
  GraduationCapIcon,
  BackpackIcon,
  BusIcon,
  StorefrontIcon,
  ForkKnifeIcon,
  PersonIcon,
  LeafIcon,
  HourglassLowIcon,
  BicycleIcon,
  CarIcon,
  ConfettiIcon,
  ShoppingCartSimpleIcon,
  BrandyIcon,
  CoffeeIcon,
  CactusIcon,
  TreeIcon,
  BabyIcon,
  FlowerLotusIcon,
} from "@phosphor-icons/react";
import { type Scores } from "@local-logic/client";

type Score = keyof Scores["location"];

const icons: {
  [key in Score]: Icon;
} = {
  high_schools: GraduationCapIcon,
  primary_schools: BackpackIcon,
  transit_friendly: BusIcon,
  groceries: StorefrontIcon,
  restaurants: ForkKnifeIcon,
  pedestrian_friendly: PersonIcon,
  greenery: LeafIcon,
  historic: HourglassLowIcon,
  cycling_friendly: BicycleIcon,
  car_friendly: CarIcon,
  vibrant: ConfettiIcon,
  shopping: ShoppingCartSimpleIcon,
  nightlife: BrandyIcon,
  cafes: CoffeeIcon,
  quiet: CactusIcon,
  parks: TreeIcon,
  daycares: BabyIcon,
  wellness: FlowerLotusIcon,
};

/**
 * @deprecated Use `ScoreIcon` instead.
 * This component is deprecated and will be removed in a future release.
 */
export const ScoreIconDeprecated = ({
  score,
  className,
  ...rest
}: {
  score: Score;
  className?: string;
}) => {
  const Icon = useMemo(() => icons[score], [score]);

  return <Icon className={className} {...rest} />;
};
